var _ellipse, _path, _ellipse2, _mask, _path2, _path3, _circle, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 57,
    viewBox: "0 0 34 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 16.5556,
    cy: 48.9111,
    rx: 15.5556,
    ry: 8.08889,
    fill: "#1192E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6111 48.9111C31.6111 50.8636 30.0792 52.7547 27.3243 54.1872C24.5941 55.6069 20.7875 56.5 16.5556 56.5C12.3236 56.5 8.51706 55.6069 5.78679 54.1872C3.03192 52.7547 1.5 50.8636 1.5 48.9111C1.5 46.9585 3.03192 45.0675 5.78679 43.635C8.51706 42.2153 12.3236 41.3222 16.5556 41.3222C20.7875 41.3222 24.5941 42.2153 27.3243 43.635C30.0792 45.0675 31.6111 46.9585 31.6111 48.9111Z",
    stroke: "#1192E8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.45,
    cx: 16.5556,
    cy: 48.9111,
    rx: 5.6,
    ry: 3.11111,
    fill: "#1192E8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_1017_2852",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 50,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 34,
    height: 50
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1111 16.5556C32.1111 20.0714 30.9447 23.3149 28.9777 25.92C28.2786 26.8927 27.3335 27.9278 26.2873 29.0736C22.6535 33.0533 17.8 38.3688 17.8 47.0444C17.8 47.7317 17.2428 48.2889 16.5556 48.2889C15.8683 48.2889 15.3111 47.7317 15.3111 47.0444C15.3111 38.3688 10.4576 33.0533 6.8238 29.0736L6.82375 29.0735C5.77758 27.9277 4.8325 26.8927 4.13343 25.92C2.16643 23.3149 1 20.0714 1 16.5556C1 7.96446 7.96446 1 16.5556 1C25.1467 1 32.1111 7.96446 32.1111 16.5556Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1111 16.5556C32.1111 20.0714 30.9447 23.3149 28.9777 25.92C28.2786 26.8927 27.3335 27.9278 26.2873 29.0736C22.6535 33.0533 17.8 38.3688 17.8 47.0444C17.8 47.7317 17.2428 48.2889 16.5556 48.2889C15.8683 48.2889 15.3111 47.7317 15.3111 47.0444C15.3111 38.3688 10.4576 33.0533 6.8238 29.0736L6.82375 29.0735C5.77758 27.9277 4.8325 26.8927 4.13343 25.92C2.16643 23.3149 1 20.0714 1 16.5556C1 7.96446 7.96446 1 16.5556 1C25.1467 1 32.1111 7.96446 32.1111 16.5556Z",
    fill: "#1192E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9777 25.92L28.1796 25.3175L28.1725 25.3268L28.1657 25.3364L28.9777 25.92ZM26.2873 29.0736L27.0258 29.7478V29.7478L26.2873 29.0736ZM6.8238 29.0736L7.56227 28.3993L7.55659 28.393L7.55081 28.3869L6.8238 29.0736ZM6.82375 29.0735L6.08528 29.7478L6.09095 29.754L6.09674 29.7601L6.82375 29.0735ZM4.13343 25.92L4.94545 25.3364L4.93858 25.3269L4.93149 25.3175L4.13343 25.92ZM29.7758 26.5226C31.8692 23.7499 33.1111 20.2963 33.1111 16.5556H31.1111C31.1111 19.8466 30.0201 22.8799 28.1796 25.3175L29.7758 26.5226ZM27.0258 29.7478C28.0598 28.6154 29.0494 27.5337 29.7897 26.5037L28.1657 25.3364C27.5079 26.2516 26.6072 27.2402 25.5488 28.3993L27.0258 29.7478ZM18.8 47.0444C18.8 38.7909 23.3878 33.7321 27.0258 29.7478L25.5488 28.3993C21.9191 32.3745 16.8 37.9468 16.8 47.0444H18.8ZM16.5556 49.2889C17.7951 49.2889 18.8 48.284 18.8 47.0444H16.8C16.8 47.1794 16.6906 47.2889 16.5556 47.2889V49.2889ZM14.3111 47.0444C14.3111 48.284 15.316 49.2889 16.5556 49.2889V47.2889C16.4206 47.2889 16.3111 47.1794 16.3111 47.0444H14.3111ZM6.08533 29.7478C9.72329 33.7321 14.3111 38.7909 14.3111 47.0444H16.3111C16.3111 37.9468 11.192 32.3745 7.56227 28.3993L6.08533 29.7478ZM6.09674 29.7601L6.09679 29.7602L7.55081 28.3869L7.55076 28.3869L6.09674 29.7601ZM3.3214 26.5037C4.06174 27.5337 5.05127 28.6153 6.08528 29.7478L7.56222 28.3992C6.50389 27.2401 5.60325 26.2516 4.94545 25.3364L3.3214 26.5037ZM0 16.5556C0 20.2963 1.24186 23.7499 3.33536 26.5226L4.93149 25.3175C3.091 22.8799 2 19.8466 2 16.5556H0ZM16.5556 0C7.41217 0 0 7.41217 0 16.5556H2C2 8.51674 8.51674 2 16.5556 2V0ZM33.1111 16.5556C33.1111 7.41217 25.6989 0 16.5556 0V2C24.5944 2 31.1111 8.51674 31.1111 16.5556H33.1111Z",
    fill: "url(#paint0_linear_1017_2852)",
    mask: "url(#path-4-outside-1_1017_2852)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 10,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333 19L21.3667 20.0333C20.7267 21.16 19.1467 22.06 17.6667 22.28V16.3333H19.6667V15H17.6667V14.2133C18.44 13.9333 19 13.2 19 12.3333C19 11.2333 18.1 10.3333 17 10.3333C15.9 10.3333 15 11.2333 15 12.3333C15 13.2 15.56 13.9333 16.3333 14.2133V15H14.3333V16.3333H16.3333V22.28C14.8533 22.06 13.2733 21.16 12.6333 20.0333L13.6667 19L11 17V19C11 21.5866 14.28 23.6666 17 23.6666C19.72 23.6666 23 21.5866 23 19V17L20.3333 19ZM17 11.6666C17.3667 11.6666 17.6667 11.9666 17.6667 12.3333C17.6667 12.7 17.3667 13 17 13C16.6333 13 16.3333 12.7 16.3333 12.3333C16.3333 11.9666 16.6333 11.6666 17 11.6666Z",
    fill: "#1192E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1017_2852",
    x1: 16.5556,
    y1: 1,
    x2: 16.5556,
    y2: 48.2889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortMarker);
export default __webpack_public_path__ + "static/media/PortMarker.f7fdfed89876e97bb36a23508ccfe521.svg";
export { ForwardRef as ReactComponent };